import { render, staticRenderFns } from "./BountyDisclaimer.vue?vue&type=template&id=e56addd6&scoped=true"
import script from "./BountyDisclaimer.vue?vue&type=script&lang=js"
export * from "./BountyDisclaimer.vue?vue&type=script&lang=js"
import style0 from "./BountyDisclaimer.vue?vue&type=style&index=0&id=e56addd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56addd6",
  null
  
)

export default component.exports